import {
  asUrl,
  getStringNoLocale,
  getUrl,
  Thing,
  ThingPersisted,
} from '@inrupt/solid-client'
import { URI } from '../utils/ontology'
import { checkType } from './utils'

export abstract class SurveyElement {
  protected readonly _thing: ThingPersisted

  protected constructor(thing: ThingPersisted) {
    checkType(thing, URI.SURVEY_SURVEY_ELEMENT_CLASS)
    this._thing = thing
  }

  get url(): string {
    return asUrl(this._thing)
  }

  get thing(): Thing {
    return this._thing
  }

  get text(): string {
    return getStringNoLocale(this.thing, URI.SURVEY_HAS_TEXT_PREDICATE) || ''
  }

  get leadsTo(): string | undefined {
    return getUrl(this.thing, URI.SURVEY_LEADS_TO_PREDICATE) || undefined
  }

  equals(el: SurveyElement): boolean {
    return Boolean(el.url) && this.url === el.url
  }
}
